// The quote drawer's StatusPicker's one write (finance-real, the user 2026-10-22): its status, and its jobs' with it. Its
// own hook, not QuoteDrawer's, because the drawer keys the picker by the status: a new picker starts with a write of its own.
import type { UseMutationResult } from "@tanstack/react-query";
import { useSetQuoteStatus } from "../../hooks/useLineJobs";
import type { QuoteBundle, QuoteStatusInput } from "../../types";

export interface StatusPickerModel {
  set: UseMutationResult<QuoteBundle, Error, { quoteId: string; input: QuoteStatusInput }>;
}

export function useStatusPicker(): StatusPickerModel {
  return { set: useSetQuoteStatus() };
}
